// 📄 components/StepCertificates.tsx
import React from 'react';
import { Globe, AlertTriangle } from 'lucide-react';
// Importamos el tipo para que coincida exactamente con la función handleFieldChange del padre
import { GeneralsFormData } from '../../../../../services/commerce/integrationService';


interface StepCertificatesProps {
  dataCenter: string;
  onChange: (field: keyof GeneralsFormData, value: any) => void; // 👈 Modificado aquí
}

export function StepCertificates({ dataCenter, onChange }: StepCertificatesProps) {
  const getDcUrl = () => {
    return dataCenter === 'europe'
      ? 'test-integration.eu.managedgateway.cloud.sap'
      : 'test-integration.us.managedgateway.cloud.sap';
  };

  return (

    <div className="space-y-4">
      {/* Guía de Ruta SPRO de SAP */}
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-4 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO en SAP ECC / S4HANA</span>
        <p className="font-mono text-xs text-gray-300 flex flex-wrap items-center gap-1.5">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400">SPRO</span>
          <span>→</span>
          <span>Integration with Other SAP Components</span>
          <span>→</span>
          <span>SAP Ariba Cloud Integration Gateway</span>
          <span>→</span>
          <span>Global Settings</span>
          <span>→</span>
          <span className="text-blue-400 underline decoration-indigo-500 font-medium">Maintain certification</span>
        </p>
      </div>

      <h3 className="text-lg font-medium text-blue-400">3. Verificación de Certificados SSL (STRUST)</h3>
      <p className="text-sm text-gray-400">Asegúrate de mapear la infraestructura y certificados del Data Center asignado.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-2">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Seleccionar Data Center (Ariba DC)</label>
          <select
            value={dataCenter}
            onChange={(e) => onChange('dataCenter', e.target.value)}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm focus:outline-none focus:border-blue-500 text-white"
          >
            <option value="usa">Estados Unidos (USA)</option>
            <option value="europe">Europa (EU)</option>
          </select>
        </div>
        <div className="md:col-span-2">
          <label className="block text-xs font-medium text-gray-400 mb-1">Endpoint de Validación Sugerido</label>
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-lg p-2.5 text-sm text-gray-300 select-all">
            <Globe className="w-4 h-4 text-blue-400 flex-shrink-0" />
            <span className="font-mono text-xs truncate">{getDcUrl()}</span>
          </div>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm mt-2">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Sincronización del Certificado raíz</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Para la región <strong>{dataCenter === 'usa' ? 'USA' : 'Europa'}</strong>, valida la cadena TLS cargada en la STRUST. Un error común de omisión causa fallos de tipo <code className="bg-black/30 px-1 rounded">NIECONN_REFUSED</code> en entornos ABAP.
          </p>
        </div>
      </div>
    </div>
  );
}